import useApi from '../../../services/useApi'

export const useGetBrandsDropdown = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/profitability/brands/dropdown',
    {
      queryId: `brands-dropdown`,
      filters: {
        search: '',
        page: 1,
        limit: 500,
        purchaser_email: '',
      },
    }
  )

  return {
    brands: response?.data || [],
    isBrandsLoading: isFetching,
  }
}
